import { AnyRoute, createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { isEqual } from 'lodash'

import { BankAlertsWrapper } from './BankAlertsWrapper'
import { ALERTS_KEY, alertsQueryOptions } from './query'
import { schema } from './schema'

const AlertsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `/`,
    component: lazyRouteComponent(() => import('./AlertsPage')),
    validateSearch: (search) => schema.parse(search),
    loaderDeps: ({ search }) => ({
      search,
      isChanged: !isEqual(schema.parse({}), search)
    }),
    loader: ({ cause, deps, context }) => {
      if (cause === 'stay') {
        return context.queryClient.getQueryData([ALERTS_KEY, deps.search]) ?? null
      }
      return (context as BPRoutingContext).queryClient.ensureQueryData(alertsQueryOptions(deps.search))
    }
  })

export const routeAlertsTree = <T extends AnyRoute>(rootRoute: T) => {
  const AlertsIndexRoute = createRoute({
    beforeLoad: async ({ context }) => {
      if (!context.accessibleRoutingFlags.alertRootAccess) {
        throw redirect({
          to: '/'
        })
      }
    },
    getParentRoute: () => rootRoute,
    path: routes.bank.alerts,
    component: BankAlertsWrapper
  })

  return AlertsIndexRoute.addChildren([AlertsRoute<typeof AlertsIndexRoute>(AlertsIndexRoute)])
}
